import { Component, OnDestroy, OnInit } from '@angular/core';
import { User, Category, Product, ProductFilter, Project, selectOption, ProjectView } from 'src/models';
import { FacadeService } from '../services/FacadeService';
import { MatDialog } from '@angular/material/dialog';
import {ProjectDialogComponent} from '../components/project-dialog/project-dialog.component';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { ThrowStmt } from '@angular/compiler';
import { castArray, isBuffer } from 'lodash';
import { ProjectSearchDialogComponent } from '../components/project-search-dialog/project-search-dialog.component';
import { MessageService } from '../services/MessageService';
import {LoginDialogComponent} from '../components/login-dialog/login-dialog.component';
import {RegistrationDialogComponent} from '../components/registration-dialog/registration-dialog.component';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { login } from '../store/user/user.action';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit, OnDestroy {  
  productHierarchy: any;
  productList: Array<Product>;
  trackItems: Array<Product>;
  searchValues: any;  
  project: Project;
  unmodifiedProject: Project;  
  user$: Observable<User>;
  user: User;
  showSpinner: boolean;
  subscription: Subscription;
  quoteErrorMessage: string;
  quoteNumber: string;
  navCustomerNo: string;
  showQuoteSpinner: boolean;
  foundQuote: Project;
  isLoadingProjects: boolean;

  constructor(private service: FacadeService, private dialog: MatDialog, private store: Store<{user: User}>, private messageService: MessageService) {     
    this.productHierarchy = {
      root: {
        subCategories: []
      }
    };
    this.productList = [];   
    this.trackItems = []; 
    this.searchValues = {};
    this.isLoadingProjects = true;

    this.user$ = store.select('user');
    this.user$.subscribe(x => {
      this.user = x;
      if(!x.isLoggedIn) {
        this.project = new Project();
        this.productList.forEach(x => x.isSelected = false);
        this.navCustomerNo = "";
        this.quoteNumber = "";
      } else {
        this.navCustomerNo = x.navCustomerNo;
      } //Will check to see if it's a user saved project
    });

    this.subscription = this.messageService.getMessage().subscribe(message => {
      if (message) {
         if(message.text === 'Launch Project Search')
             this.onProjectSearchLaunch();        
      } 
    });
    
    this.unmodifiedProject = new Project();
    this.project = new Project();
  }

  ngOnInit(): void {
    this.service.productService.GetProducts(new ProductFilter()).then(data => {
      const {categories, products, trackItems} = data as any;
      this.productHierarchy.root = {
        subCategories: categories as Array<Category>,
        isOpen: true,
        isVisible: true,
        products: []
      };
      this.productHierarchy.root.subCategories.forEach(element => {
        element.isRoot = true;
      });   
      this.productList = _.orderBy(products, 'productCode', 'asc'); 
      this.trackItems = trackItems;
      this.isLoadingProjects = false;
    });          
  }

  ngOnDestroy() {    
    this.subscription.unsubscribe();
   }

  onAccordionToggle(e, node){
    let isClosing = false;

    this.productHierarchy.root.subCategories.forEach(function iter(a) {
      if(a.lineNo === node.lineNo && a.parentLineNo === node.parentLineNo) { 
        a.isOpen = !a.isOpen;
        isClosing = !a.isOpen;
      } else if (isClosing && a.isOpen) {
        //Close Children
        let tree = a.path.split('|').map(Number);
        if(tree.includes(node.lineNo))        
          a.isOpen = false;
      }

      Array.isArray( a.subCategories) && a.subCategories.forEach(iter);
   });             
  }

  matchingCategoryProducts(category: Category){
    if(!category.path || category.subCategories.filter(x => x.isVisible).length > 0) return Array<Product>();

    let pathList = Array<string>();
    pathList.push(category.path);
    category.subCategories.filter(x => x.isVisible == false).forEach(x => pathList.push(x.path));
    let productList = this.productList.filter(x => pathList.includes(x.path));

    return productList;
  }

  filteredProductList(lineNo: number, products: Array<Product>): Array<Product>{
    if(this.searchValues[lineNo]){
      const fltrValue = this.searchValues[lineNo];
      return products.filter(x => x.productCode.toLowerCase().indexOf(fltrValue.toLowerCase()) >= 0);
    }

    return products;
  }

  onRemoveProduct(product){
    let p = this.productList.find(x => x.productCode == product.productCode && x.path == product.path);
    p.isSelected = false;
  }

  onProductSelected() {
    this.project.isQuote = false;
  }

  onSaveProject(){     
    if(!this.user.isLoggedIn) {
      this.onLogin();
      return;
    }

    this.showSpinner = true;

    let p = { Project: Object.assign({}, this.project)}.Project as any;
    if(p.projectName === 'Unnamed') p.projectName = '';
    p.products = this.productList.filter(x => x.isSelected);

    console.log(p.products.length);

    if(p.addTrack) {
      var selectedItems = _.map(p.products, x  => x.productCode);
      var matchingTracks = this.trackItems.filter(x => selectedItems.includes(x.studItem));
      p.products = p.products.concat(matchingTracks);
    }

    if(p.projectId === 0){
    const dialogRef = this.dialog.open(ProjectDialogComponent, {
      data: {Project: p, View: ProjectView.Save},
      autoFocus: false,
      position: { top: '20px' }
    });
    this.showSpinner = false;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadProject(result.project)    
      }
     
    });
  } else {
    this.service.productService.SaveProject(p).then(x => {
       this.project = p;
       this.unmodifiedProject = _.cloneDeep(this.project);
       this.unmodifiedProject.products = this.unmodifiedProject.products.filter(x => !x.isTrackItem);
       this.showSpinner = false;
    });
   }
  }

  onEditProject(){
    let p = { Project: Object.assign({}, this.project)}.Project as any;
    if(p.projectName === 'Unnamed') p.projectName = '';
    p.products = this.productList.filter(x => x.isSelected);

    if(p.addTrack) {
      var selectedItems = _.map(p.products, x  => x.productCode);
      var matchingTracks = this.trackItems.filter(x => selectedItems.includes(x.studItem));
      p.products = p.products.concat(matchingTracks);
    }

    const dialogRef = this.dialog.open(ProjectDialogComponent, {
      data: {Project: p, View: ProjectView.Save},
      autoFocus: false,
      position: { top: '20px' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.success) {
       this.loadProject(result.project);
      } else {
        alert('There was an error saving your project');
      }
    });
  }

  onCopyProject() {
    let p = { Project: Object.assign({}, this.project)}.Project as any;
    p.projectId = 0;
    p.products = this.productList.filter(x => x.isSelected);

    const dialogRef = this.dialog.open(ProjectDialogComponent, {
      data: {Project: p, View: ProjectView.Copy},
      autoFocus: false,
      position: { top: '20px' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadProject(result.project)    
      }
    });
  }

  onDownloadPdf() {    
    let p = { Project: Object.assign({}, this.project)}.Project as any;
    
    if(p.projectName === 'Unnamed') p.projectName = '';
    p.products = this.productList.filter(x => x.isSelected);

    if(p.addTrack) {
      var selectedItems = _.map(p.products, x  => x.productCode);
      var matchingTracks = this.trackItems.filter(x => selectedItems.includes(x.studItem));
      p.products = p.products.concat(matchingTracks);
    }

    const dialogRef = this.dialog.open(ProjectDialogComponent, {
      data: {Project: p, View: ProjectView.SaveAndDownload},
      autoFocus: false,
      position: { top: '20px' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.success) {
       this.loadProject(result.project);
      } else {
        alert('There was an error saving your project');
      }
    });
  }

  onEmailPdf() {    
    if(!this.user.isLoggedIn) return;
    let p = { Project: Object.assign({}, this.project)}.Project as any;
    
    if(p.projectName === 'Unnamed') p.projectName = '';
    p.products = this.productList.filter(x => x.isSelected);

    if(p.addTrack) {
      var selectedItems = _.map(p.products, x  => x.productCode);
      var matchingTracks = this.trackItems.filter(x => selectedItems.includes(x.studItem));
      p.products = p.products.concat(matchingTracks);
    }

    const dialogRef = this.dialog.open(ProjectDialogComponent, {
      data: {Project: p, View: ProjectView.SaveAndEmail},
      autoFocus: false,
      position: { top: '20px' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.success) {
        this.loadProject(result.project);

        this.dialog.open(ConfirmationDialogComponent, 
          {data: {
              hideFooter: true, 
              title: "Email Sent", 
              label: `An email has been sent to ${result.emailAddress}`,
              className: 'md'
            }, 
          autoFocus: false, position: { top: '10px' }}); 
       } else {
         alert('There was an error saving your project');
       }
    });
  }

  onDownloadZip() {
    let p = { Project: Object.assign({}, this.project)}.Project as any;
    
    if(p.projectName === 'Unnamed') p.projectName = '';
    p.products = this.productList.filter(x => x.isSelected);

    if(p.addTrack) {
      var selectedItems = _.map(p.products, x  => x.productCode);
      var matchingTracks = this.trackItems.filter(x => selectedItems.includes(x.studItem));
      p.products = p.products.concat(matchingTracks);
    }

    const dialogRef = this.dialog.open(ProjectDialogComponent, {
      data: {Project: p, View: ProjectView.SaveAndZip},
      autoFocus: false,
      position: { top: '20px' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.success) {
       this.loadProject(result.project);
      } else {
        alert('There was an error saving your project');
      }
    });
  }

  onReset(){
    this.unmodifiedProject = new Project();
    this.project = new Project();
    this.productList.forEach(x => x.isSelected = false);
  }

  onUndo() {
    this.loadProject(this.unmodifiedProject);
  }

  onQuoteNumberChange(val){
    if(!val) this.quoteErrorMessage = '';
  }

  searchForQuote() {
    this.showQuoteSpinner = true;
    this.quoteErrorMessage = '';

    this.service.productService.SearchForQuote(this.navCustomerNo, this.quoteNumber).then(data => {
      const {quote} = data as any;
      if(!quote){
        this.quoteErrorMessage = "Unable to locate a quote matching the information provided.";
        this.showQuoteSpinner = false;
        return;
      }

      if(this.user.isLoggedIn && this.user.navCustomerNo) {
        this.loadQuote(quote);
        this.showQuoteSpinner = false;
        return;
      }

      let label = this.user.isLoggedIn ? "Would you like to save your customer number to your user account?" : "Would you like to save your customer information?";
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, 
        {data: {confirmationText: "Yes", rejectionText: "No", label: label}, 
        autoFocus: false, position: { top: '10px' }});    
  
      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          if(!this.user.isLoggedIn) {
            this.foundQuote = quote;
            this.onLogin();
          } else {
            this.foundQuote = quote;
            this.saveCustomerNoAndLoadQuote();
          }
        } else {
          this.loadQuote(quote);
          this.showQuoteSpinner = false;
          this.foundQuote = null;
        }
      });
    });
  }

  saveCustomerNoAndLoadQuote() {
    this.service.productService.SaveCustomerNo(this.foundQuote.customerNo).then(u => {
      const newUser = {...this.user, navCustomerNo: this.foundQuote.customerNo};
      this.store.dispatch(login({user: newUser}));
      this.loadQuote(this.foundQuote);
      this.showQuoteSpinner = false;
      this.foundQuote = null;
   });  
  }

  loadQuote(quote: Project) {
    this.onReset();
    let quoteProducts = quote.products.map(x => x.productCode);
    this.productList.filter(x => quoteProducts.some(q => q === x.productCode)).forEach(p => p.isSelected = true);
    
    // Format date as DD-MM-YYYY
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const year = today.getFullYear();
    const dateString = `${day}-${month}-${year}`;
    if (!(quote.jobIDRSWSG))
    {
      quote.jobIDRSWSG = 'Job';
    }

    this.project.projectName = `${quote.jobIDRSWSG} Submittals (${quote.projectName}) ${dateString}`;
    this.project.isQuote = true;
    this.project.addTrack = false;
  }

  loadProject(project: Project) {
    if(project.projectId === 0) return;
    this.project = project;
    this.productList.forEach(p => p.isSelected = false);

    console.log('loading project');
    console.log(project);
    console.log(this.productList);
   for(var i = 0; i < this.project.products.length; i++) {
     let x = this.project.products[i];
     let p = this.productList.find(p => p.productCode == x.productCode && p.path == x.path);
     if(p) {
      p.isSelected = true;
      this.project.products[i] = p;
     }
   }

   this.project.products = _.orderBy(this.project.products.filter(x => !x.isTrackItem), 'productCode', 'asc');

   if(this.user.isLoggedIn)
      this.unmodifiedProject = _.cloneDeep(this.project);
  }

  onProjectSearchLaunch() {
    const dialogRef = this.dialog.open(ProjectSearchDialogComponent , {data: {customerNo: this.navCustomerNo}, autoFocus: false, position: { top: '10px' }});    

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result.isQuote)
          this.loadQuote(result);
        else
          this.loadProject(result);
        console.log(result);
      }
    });
  }

  onLogin() {    
    const dialogRef = this.dialog.open(LoginDialogComponent, {autoFocus: false, position: { top: '10px' }});    
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.register) {
       this.onRegister();
      }else if(result) {
        if(this.showQuoteSpinner) {
          this.saveCustomerNoAndLoadQuote();
          return;
        }

        this.onSaveProject();
      } else {
        this.showQuoteSpinner = false;
        this.foundQuote = null;
      }
    });
  }

  onRegister() {
    let customerNo = this.foundQuote ? this.foundQuote.customerNo : '';
    const dialogRef = this.dialog.open(RegistrationDialogComponent, { data: {navCustomerNo: customerNo}, autoFocus: false, position: { top: '10px' }});  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {    
        if(this.showQuoteSpinner) {
          this.showQuoteSpinner = false;
          this.loadQuote(this.foundQuote);
          return;
        }
        this.onSaveProject();
      } else {
        this.showQuoteSpinner = false;
        this.foundQuote = null;
      }
    });
  }

  
  get selectedProducts(): Array<Product> {
    return this.productList.filter(x => x.isSelected);
  }

  get selectedCategories() : Array<Product> {
    //distinct categories
    const selectedProducts = this.selectedProducts;
    const categoryLineNos = [... new Set(selectedProducts.map(m => m.categoryLineNo))].sort();
    
    let products = new Array<Product>();
    categoryLineNos.forEach(c => {
        products.push(this.selectedProducts.find(p => p.categoryLineNo === c));
    });
    
    return products;
  }

  get hasUnsavedChanges(): boolean {
    let p = _.cloneDeep(this.project);
    p.products = this.productList.filter(x => x.isSelected);

    return !_.isEqual(p, this.unmodifiedProject);      
  }
}